import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WidgetsTypeEnum } from 'src/app/enums/widgets/widgets-type.enum';
import { WidgetsAbstract } from 'src/app/abstract/widgets/widgets.abstract';
import { CdkDrag, CdkDragDrop } from '@angular/cdk/drag-drop';
import { WidgetsContainerComponentAbstract } from 'src/app/abstract/widgets/widgets-container-component.abstract';
import { WidgetsArrayModel } from 'src/app/models/widgets/widgets-array.model';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import { CommandService } from 'src/app/services/command/command.service';
import { Logger } from 'src/app/core/logger';
import { WidgetsNotifyDeleteService } from 'src/app/services/widgets/widgets-notify-delete.service';
import { WidgetsSelectionService } from 'src/app/services/widgets/widgets-selection.service';
@Component({
  selector: '[appWidgetsArray]',
  templateUrl: './widgets-array.component.html',
  styleUrls: ['./widgets-array.component.scss']
})
export class WidgetsArrayComponent extends WidgetsContainerComponentAbstract implements OnInit {
  @Input() data: WidgetsArrayModel = new WidgetsArrayModel();
  @Input() dropListIds: string[] = [];
  @Output() dropListIdAdded: EventEmitter<string> = new EventEmitter<string>();

  constructor(private widgetsService: WidgetsService,
    private commandService:CommandService,
    private selectionService: WidgetsSelectionService,
    private notifyDeleteService: WidgetsNotifyDeleteService,
    private logger: Logger) {
    super();
  }

  ngOnInit(): void {
  }

  onWidgetDroppedToCanvas(event: CdkDragDrop<WidgetsAbstract[], WidgetsAbstract[], any>): WidgetsAbstract {
    // TODO CHECK if this change is working for Arrays as well. ParentId was not used...
    return this.commandService.execute(this.data, event.item.data);
  }

  isDroppableWidget(item: CdkDrag<WidgetsAbstract>) {
    // Constraints: QUESTION, FIELD, TEXT, RADIO, INPUT widgets are allowed under an ARRAY
    if((this.data as any).length>0){
      return false;
    }

    switch (item.data.widgetType) {
      case WidgetsTypeEnum.QUESTION:
        case WidgetsTypeEnum.FIELD:
        case WidgetsTypeEnum.TEXT:   
        case WidgetsTypeEnum.RADIO: 
        case WidgetsTypeEnum.INPUT:
        case WidgetsTypeEnum.CHECKBOX:  
        case WidgetsTypeEnum.TIME_RANGE:
        case WidgetsTypeEnum.ORDINAL_IN_SET:     
        return true;
    }

    return false;
  }

  onDeleteModal(): void {
    this.notifyDeleteService.notifyDelete(this.data);    
  }
 
  clone(WidgetsAbstract: any): WidgetsAbstract {
    throw new Error('Method not implemented.');
  }

  onWidgetsReordered(culprits: WidgetsAbstract[]) {
    throw new Error('Method not implemented.');
  }  

  onSelect($event) {
    this.selectionService.toggleSelection(this.data);
  }  
}

